import { motion } from "framer-motion";
import { Mail, Phone, MapPin, Instagram, Youtube, Send } from "lucide-react";
import { WA_LINK } from "@/components/landing/FloatingWhatsApp";

export default function Footer() {
  return (
    <footer
      id="kontak"
      className="relative bg-forest text-parchment pt-24 pb-10 overflow-hidden"
      data-testid="footer"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/34256958/pexels-photo-34256958.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
          backgroundSize: "cover",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="border-b border-gold/20 pb-16 grid grid-cols-1 md:grid-cols-12 gap-10 items-center"
        >
          <div className="md:col-span-3 flex md:justify-start">
            <img
              src="https://customer-assets.emergentagent.com/job_generasi-flow/artifacts/fgw1jyfc_LOGO%20PONDOK%20GRQ%202022_alter.png"
              alt="Logo Pondok GRQ"
              className="h-32 md:h-40 w-auto object-contain"
              style={{
                filter:
                  "drop-shadow(1px 0 0 #ffffff) drop-shadow(-1px 0 0 #ffffff) drop-shadow(0 1px 0 #ffffff) drop-shadow(0 -1px 0 #ffffff) drop-shadow(1px 1px 0 #ffffff) drop-shadow(-1px -1px 0 #ffffff) drop-shadow(1px -1px 0 #ffffff) drop-shadow(-1px 1px 0 #ffffff) drop-shadow(0 6px 24px rgba(197,155,75,0.25))",
              }}
            />
          </div>
          <div className="md:col-span-9">
            <p className="font-arabic text-3xl md:text-4xl text-gold">
              وَلَقَدْ يَسَّرْنَا الْقُرْآنَ لِلذِّكْرِ
            </p>
            <h3 className="mt-6 font-serif-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
              Generasi Rabbani<br />
              <span className="italic text-gold">Qurani</span>
            </h3>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 py-16">
          <div className="md:col-span-5">
            <p className="text-parchment/70 leading-relaxed max-w-md">
              Pondok Tahfizh yang membersamai santri hingga menuntaskan 30 juz.
            </p>
            <div className="mt-8 flex gap-3">
              <SocialBtn
                label="Instagram"
                Icon={Instagram}
                testid="social-ig"
                href="https://www.instagram.com/pondoktahfizhgrq/"
              />
              <SocialBtn
                label="YouTube"
                Icon={Youtube}
                testid="social-yt"
                href="https://www.youtube.com/watch?v=tDldFoIICNQ"
              />
              <SocialBtn label="WhatsApp" Icon={Send} testid="social-wa" href={WA_LINK} />
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4">Kontak</p>
            <ul className="space-y-3 text-parchment/80 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-gold mt-0.5 flex-shrink-0" />
                <a
                  href="https://share.google/38mR5qzO3BaMBl7tw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors leading-relaxed"
                  data-testid="footer-address-map"
                >
                  Komplek Villa Bandung Indah B5-17, Cileunyi Kulon, Cileunyi, Kab. Bandung, Jawa Barat 40623
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-gold" />
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors"
                  data-testid="footer-phone-wa"
                >
                  +62 811-2002-352
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold" />
                <a
                  href="mailto:grqtahfizh@gmail.com"
                  className="hover:text-gold transition-colors"
                  data-testid="footer-email"
                >
                  grqtahfizh@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4">Tautan</p>
            <ul className="space-y-2 text-parchment/80 text-sm">
              <li><a href="#tentang" className="hover:text-gold transition-colors">Tentang</a></li>
              <li><a href="#program" className="hover:text-gold transition-colors">Program</a></li>
              <li><a href="#galeri" className="hover:text-gold transition-colors">Galeri</a></li>
              <li><a href="#pendaftaran" className="hover:text-gold transition-colors">Pendaftaran</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4">Jadwal</p>
            <ul className="space-y-2 text-parchment/80 text-sm">
              <li>Senin – Jum&apos;at</li>
              <li className="text-parchment/60">08.00 – 16.00 WIB</li>
              <li className="pt-2">Sabtu</li>
              <li className="text-parchment/60">08.00 – 12.00 WIB</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gold/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-parchment/50">
            © {new Date().getFullYear()} Pondok Tahfizh Generasi Rabbani Qurani. Seluruh hak cipta dilindungi.
          </p>
          <p className="text-xs text-parchment/50">Barakallahu fiikum.</p>
        </div>
      </div>
    </footer>
  );
}

function SocialBtn({ label, Icon, testid, href }) {
  return (
    <a
      href={href || "#"}
      target={href && href !== "#" ? "_blank" : undefined}
      rel={href && href !== "#" ? "noopener noreferrer" : undefined}
      aria-label={label}
      data-testid={testid}
      className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center text-parchment/80 hover:bg-gold hover:text-forest hover:border-gold transition-all duration-500"
    >
      <Icon size={16} />
    </a>
  );
}
